import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MovieCreditsComponent } from './movie-credits/movie-credits.component';
import { MovieMoreInformationComponent } from './movie-more-information/movie-more-information.component';
import { MovieReasonsToWatchComponent } from './movie-reasons-to-watch/movie-reasons-to-watch.component';
import { MovieReviewsComponent } from './movie-reviews/movie-reviews.component';
import { MovieSynopsisComponent } from './movie-synopsis/movie-synopsis.component';
import { MovieTellFriendsComponent } from './movie-tell-friends/movie-tell-friends.component';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { MovieTitleComponent } from './movie-title/movie-title.component';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SeeMoreComponent } from './see-more/see-more.component';
import { SharedUiPictureModule } from '@usheru-hff/shared/ui-picture';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { MovieInfoCreditsComponent } from './movie-info-credits/movie-info-credits.component';
import { AssetsLockerUiAccessLinkModule } from '../../../../assets-locker/ui-assets-locker-link/src/lib/assets-locker-ui-access-link.module';
import { AssetsLockerPageModule } from '../../../../assets-locker/feature-assets-locker/src/lib/assets-locker-page.module';
import {MovieRatingComponent} from "./movie-rating/movie-rating.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    SharedUtilsTranslationModule,
    SharedUtilsModule,
    FontAwesomeModule,
    SharedUiPictureModule,
    SharedUtilsImageModule,
    TooltipModule
  ],
  declarations: [
    MovieCreditsComponent,
    MovieMoreInformationComponent,
    MovieReasonsToWatchComponent,
    MovieReviewsComponent,
    MovieRatingComponent,
    MovieSynopsisComponent,
    MovieTellFriendsComponent,
    MovieTitleComponent,
    SeeMoreComponent,
    MovieInfoCreditsComponent
  ],
  exports: [
    MovieCreditsComponent,
    MovieMoreInformationComponent,
    MovieReasonsToWatchComponent,
    MovieReviewsComponent,
    MovieRatingComponent,
    MovieSynopsisComponent,
    MovieTellFriendsComponent,
    MovieTitleComponent,
    SeeMoreComponent,
    MovieInfoCreditsComponent,
    AssetsLockerUiAccessLinkModule
  ]
})
export class MovieDetailUiMovieElementsModule {}
